import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { AppInjector } from '../app-injector';

import { FeatureToggleService } from './feature-toggle.service';
import { SpaActivatedRouteSnapshot, SpaRedirectActivatedRouteSnapshot } from './models';
import { TokenService } from './token.service';

export const PermissionGuard: CanActivateFn = (route: SpaActivatedRouteSnapshot) => {
  const tokenService = AppInjector.injector.get(TokenService);
  const router = AppInjector.injector.get(Router);
  if (route.data?.permission) {
    const canActivate = tokenService.hasPermission(route.data?.permission);
    if (!canActivate) {
      router.navigateByUrl('home');
    }
    return canActivate;
  }
  return true;
};

export const RedirectGuard: CanActivateFn = (route: SpaRedirectActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const tokenService = AppInjector.injector.get(TokenService);
  const featureToggleService = AppInjector.injector.get(FeatureToggleService);
  const router = AppInjector.injector.get(Router);

  const children = route.parent?.routeConfig?.children ?? [];
  for (const childRoutes of children) {
    const routePermissions = childRoutes.data?.['permission'] || [];
    const routeFeatures = childRoutes.data?.['features'] || [];
    if (tokenService.hasPermission(routePermissions) && featureToggleService.hasFeature(routeFeatures)) {
      return router.parseUrl(`${state.url}/${childRoutes.path}`);
    }
  }

  return router.parseUrl('/home');
};
